 (function () {
  const COOKIE_NAME = 'dw_cookies_popup';  
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;
  const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

  function setCookie(name, value, expiryMs) {
    const expires = new Date(Date.now() + expiryMs).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; secure;`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function initUserCookie() {
    const cookieValue = getCookie(COOKIE_NAME);

    if (!cookieValue) {
      // First visit: set cookie to "0|timestamp" for 24 hours
      const timestamp = Date.now();
      setCookie(COOKIE_NAME, `0|${timestamp}`, ONE_YEAR_MS);
    } else {
      const [value, timestamp] = cookieValue.split('|');
      const now = Date.now();
      if (value === '0' && timestamp && now - parseInt(timestamp) > ONE_DAY_MS) {
        // More than 24 hours passed since first visit
        setCookie(COOKIE_NAME, '1', ONE_YEAR_MS);
      }
    }
  }

  function showPromoBlock() {
    const cookieValue = getCookie("dw_cookies_popup");
    const newPromo = document.querySelectorAll('.js-new-promo-block');
    const returnPromo = document.querySelectorAll('.js-return-promo-block');
    if (cookieValue && cookieValue.startsWith('1')) {
      returnPromo.forEach(promo => {
        promo.classList.remove('hidden');
      });
      newPromo.forEach(promo => {
        // promo.classList.add('hidden');
        promo.remove();
      });
    }
  }
  // Initialize on page load
  initUserCookie();
  showPromoBlock();
})();